import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c3472b80&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c3472b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3472b80",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderCity: require('/src/components/HeaderCity.vue').default,BaseBreadCrumbs: require('/src/components/BaseBreadCrumbs.vue').default,TabsCity: require('/src/components/TabsCity.vue').default,MapComponent: require('/src/components/MapComponent.vue').default,CardSummary: require('/src/components/CardSummary.vue').default,GoogleAds: require('/src/components/GoogleAds.vue').default,CardDistricts: require('/src/components/CardDistricts.vue').default,CardLabels: require('/src/components/CardLabels.vue').default,CardCompare: require('/src/components/CardCompare.vue').default,CardPopulation: require('/src/components/CardPopulation.vue').default,CardWeather: require('/src/components/CardWeather.vue').default,CardEconomy: require('/src/components/CardEconomy.vue').default,CardRealEstate: require('/src/components/CardRealEstate.vue').default,CardSecurity: require('/src/components/CardSecurity.vue').default,CardPolitical: require('/src/components/CardPolitical.vue').default,CardServices: require('/src/components/CardServices.vue').default,CardCityHall: require('/src/components/CardCityHall.vue').default,CardNearCities: require('/src/components/CardNearCities.vue').default,CardReviews: require('/src/components/CardReviews.vue').default,MainContainer: require('/src/components/MainContainer.vue').default})
